import PurchaseConfirmationModalBuy from './purchaseConfirmationModalBuy'

export default PurchaseConfirmationModalBuy
